import * as React from 'react';
import { UIText2, Chips, IChipsOption } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IFiltersProps {
  filtersProps: IFilterProps[];
  testId?: string;
}

export interface IFilterProps {
  label: string;
  options: IChipsOption<string>[];
  value: string;
  onChange: (value: string) => void;
}

export const Filters: React.FunctionComponent<IFiltersProps> = ({ filtersProps, testId }) => {
  return (
    <div className={styles['container']} data-testid={testId}>
      {filtersProps.map(({ label, value, options, onChange }, i) => (
        <div key={i} className={styles['item']}>
          <div className={styles['label']}>
            <UIText2>{label}</UIText2>
          </div>
          <Chips
            size="S"
            selectType="oneOf"
            value={[value]}
            options={options}
            onChange={values => onChange(values[0])}
          />
        </div>
      ))}
    </div>
  );
};
